import React from 'react'
import "./QalGuasaMahberDetails.css"
import ImgPr from "../assets/pastor.jpg";


const QalGuasaMahberDetails = () => {
  return (
    <div className='bg-container'>
        <div className='main-container'>
            <h1>መልእኽቲ ጓሳ ማሕበር</h1>
            <div className='img-container'>
                <img className="image-pr"
                src={ImgPr} alt="Pr" />
                <span>ጓሳ ማሕበር ሻሎም ወሓዚ ህይወት ቤትክርስትያን ኡጋንዳ - ፓ/ር ኣስመሮም ገብረገርግሽ (ፓ/ር ኤልያስ)</span>
            </div>
            <div className='pr-msg'>
                <p>
                ብመጀመርታ ኣብ ኩሉ ኩርንዓት ዓለም ትርከቡ ቁዱሳን ህዝቢ ኣምላኽ ካብ እግዚኣብሄር ኣቦናን ጐይታና መድሓኒና የሱስ ክርስቶስን ጸጋን ሰላምን ንዓኹምን ንቤትኩምን ንዘለኩም ኩሉን ይኹን። ካብኡ ብምቅጻል ሻሎም ወሓዚ ህይወት ቤተክርስትያን ሓንቲ ካብተን ኣብ ምድሪ ስደት ኣብ ካምፓላ፣ ኡጋንዳ ንህዝባ ብቋንቋኡ ብትግርኛ ወንጌል ምብጻሕ ዝብል ራእይ ሒዛ ብምግልጋል ብጻጋ ኣምላኽ እናተሃንጸትን ብረዲኤት መንፈስ ቅዱስ እናዓበየትን ትኸይድ ዘላ ማሕበር ኮይና፡ ካብ ብዕለት 27 ሕዳር 2005 ጀሚራ ከም ማሕበር ኮይና ዝተደኮነት እያ። እዛ ማሕበር ኣብዚ ግዜ ክሳዕ 450 ምእመን ከምኡ’ውን ኣስታት 350 ህጻናት ከኣ ይርከብዋ።
                </p>
                <p>
                እዛ ማሕበር ኣብዚ ግዜ’ዚ ናይ ገዛእ ርእሳ ህንጻ ኣብ ከተማ ካምፓላ: ኡጋንዳ ብምውናን ብዙሕ መንፈሳዊ መደባትን ንጥፈታትን እናኣካየደት ብምንገዲ ማሕበራዊ ሜድያታት ኣብ <a href="https://www.facebook.com/profile.php?id=100066395030856" target="_blank" rel="noreferrer">FaceBook</a> and <a href='https://www.youtube.com/channel/UCAob6-UU0yyO8BJ4PdcgDYw' target="_blank" rel="noreferrer">YouTube</a> ቀጥታዊ ፈነወ(Live Streaming) እናዘርግሐት ንብዙሓት ንበረኸት ትኸውን ኣላ። ሕጅ ከኣ ኣምላኽ ረዲኡና ናይ ገዛእ ርእስና መርበብ ሓበሬታ(Web Site) ክንከፍት በቒዕና ኣሎና እሞ፡ ነዚ ጀሚሩ ዘሎ መርበብ ሓበሬታ ሻሎም ወሓዚ ህይወት ቤተክርስትያን ወይ ከኣ <span>www.shalomlsc.org</span> ብምጥቃም ዘድሊ ሓበሬታ ናይ ማሕበር ክትረኽቡ ይምሕጸን። ጐይታ ይባርኽኩም!
                </p>
                <p>ጓሳ ማሕበር</p>
                <p>ፓ/ር ኣስመሮም ገብረገርግሽ (ፓ/ር ኤልያስ)</p>
            </div>            
        </div>
    </div>
  )
}

export default QalGuasaMahberDetails